<template>
  <div class="inner-card" :style="{ background: backgroundColor }">
    <loading :active.sync="isLoading" :enforce-focus="false" loader="dots" />

    <ValidationObserver v-slot="{ handleSubmit }">
      <div class="row">
        <div class="col-md-6">
          <div class="field">
            <div class="field-title">
              <span class="mark">*</span>
              <span :style="{ color: fontColor }">
                是否有取得或正在申請中之智財（專利、商標、著作權或其他）
                <p class="en-text">
                  Is there any IP obtained or being applying (patent, trademark,
                  copy right, or others)
                </p>
              </span>
            </div>
            <div class="field-radio">
              <label>
                <input type="radio" :value="true" v-model="HasIP" />
                <span>是 (Yes)</span>
              </label>
              <label>
                <input type="radio" :value="false" v-model="HasIP" />
                <span>否 (No)</span>
              </label>
            </div>
          </div>
        </div>

        <div class="col-md-6"></div>

        <template v-for="(item, index) in intellectualProperty">
          <div class="col-md-6" :key="'IPCategory' + index + index">
            <div class="field">
              <div class="field-title">
                <span class="mark">*</span>
                <span :style="{ color: fontColor }">
                  請提供以下資訊
                  <p class="en-text">Please select one option</p>
                </span>
              </div>
              <div class="field-value">
                <ValidationProvider
                  class="w-100"
                  v-slot="{ errors }"
                  rules="required"
                >
                  <el-select
                    class="w-100"
                    placeholder="請選擇"
                    v-model="item.IPCategory"
                  >
                    <el-option
                      v-for="opening in intellectualPropertyOptions"
                      :key="opening.value"
                      :label="opening.label"
                      :value="opening.value"
                    >
                      <div
                        style="
                          text-overflow: ellipsis;
                          overflow: hidden;
                          max-width: calc(100vw - 135px);
                          white-space: nowrap;
                        "
                      >
                        {{ opening.label }}
                      </div>
                    </el-option>
                  </el-select>
                  <span v-if="errors[0]" class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
            </div>
          </div>

          <div
            class="col-md-6"
            :key="'IPCategory' + index"
            style="margin-top: 30px"
          >
            <div class="field">
              <div class="field-title">
                <span class="mark">*</span>
                <span :style="{ color: fontColor }">
                  智財字號
                  <span class="en-text">IP code</span>
                </span>
              </div>
              <div class="field-value">
                <ValidationProvider
                  class="w-100"
                  v-slot="{ errors }"
                  rules="required"
                >
                  <el-input
                    type="text"
                    v-model="item.IPCode"
                    maxlength="200"
                    placeholder="請輸入"
                  ></el-input>
                  <span v-if="errors[0]" class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div class="col-md-12" :key="'Description' + index">
            <div class="field">
              <ValidationProvider
                class="w-100"
                v-slot="{ errors }"
                rules="required"
              >
                <div class="field-title">
                  <span class="mark">*</span>
                  <span :style="{ color: fontColor }">
                    說明
                    <span class="en-text">Description</span>
                  </span>
                </div>
                <div class="field-value">
                  <el-input
                    type="textarea"
                    :rows="5"
                    maxlength="200"
                    show-word-limit
                    :placeholder="
                      item.IPCategory > -1
                        ? intellectualPropertyOptions.find(
                            (x) => x.value === item.IPCategory
                          ).placeholder
                        : ''
                    "
                    v-model="item.Description"
                  />
                </div>
                <span v-if="errors[0]" class="text-danger">
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
          </div>

          <div
            v-if="intellectualProperty.length > 1"
            class="col-md-6"
            :key="'button' + index"
          >
            <button type="button" class="btn-sm del-btn" @click="del(index)">
              {{ $t("BUTTON.RESUME_DELETE") }}
            </button>
          </div>

          <div class="col-md-6" :key="'del' + index"></div>
        </template>
      </div>

      <div class="edit-btn-wrap">
        <!-- 新增 -->
        <button v-if="HasIP" type="button" class="btn-sm add-btn" @click="add">
          {{ $t("BUTTON.RESUME_ADD") }}
        </button>
        <!-- 儲存 -->
        <button type="button" class="put-btn" @click="handleSubmit(saveIP)">
          {{ $t("BUTTON.RESUME_SAVE") }}
        </button>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["source", "matchId"],
  name: "AseIDLIntellectualProperty",

  data() {
    return {
      HasIP: null,
      intellectualProperty: [],

      backgroundColor: "#f1f1f1",
      fontColor: "#000",
      intellectualPropertyOptions: [
        {
          label: "已取得專利 (patent, patent no. obtained)",
          value: 0,
          placeholder: "請填專利號（OO技術性研發專案或OO商業性管理資訊等。請勿揭露前雇主營業秘密之詳細內容。）",
        },
        {
          label: "申請中專利 (patent that is applying, public no.)",
          value: 1,
          placeholder: "請填公開號（OO技術性研發專案或OO商業性管理資訊等。請勿揭露前雇主營業秘密之詳細內容。）",
        },
        {
          label: "已取得商標 (trade mark obtained, trade mark no.)",
          value: 2,
          placeholder: "請填寫註冊號（OO技術性研發專案或OO商業性管理資訊等。請勿揭露前雇主營業秘密之詳細內容。）",
        },
        {
          label:
            "著作(包含已對外發表之出版品、期刊、論文或其他著作) (publicized publication, journal, thesis or other writings)",
          value: 3,
          placeholder: "請填寫著作名稱（OO技術性研發專案或OO商業性管理資訊等。請勿揭露前雇主營業秘密之詳細內容。）",
        },
        {
          label:
            "封測領域之其他智財 (Other IP in the field of Packaging and Testing)",
          value: 4,
          placeholder: "OO技術性研發專案或OO商業性管理資訊等。請勿揭露前雇主營業秘密之詳細內容。",
        },
      ],
    };
  },

  methods: {
    // 儲存 智財
    saveIP() {
      this.$api.idl
        .putIP(this.source, {
          Details: this.intellectualProperty,
          UserId:
            this.source === "resume" ? this.$cookies.get("candidateId") : null,
          MatchId: this.source === "personnelInformation" ? this.matchId : null,
        })
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "智財儲存成功",
              type: "success",
              duration: 2000,
            });
            if (this.source === "resume") {
              this.$store.dispatch("GetResumeCompleteness");
            }
            this.getIP();
          }
        });
    },

    // 取得 智財
    getIP() {
      const candidate =
        this.source === "resume"
          ? this.$cookies.get("candidateId")
          : this.matchId;
      this.updateLoading(true);
      this.$api.idl.getIP(this.source, candidate).then((response) => {
        if (response.status === 200) {
          this.HasIP = response.data.HasIP;
          this.intellectualProperty = response.data.Details;
        }
        this.updateLoading(false);
      });
    },

    add() {
      this.intellectualProperty.push({});
    },

    del(index) {
      this.intellectualProperty.splice(index, 1);
    },

    // loading
    ...mapActions(["updateLoading"]),
  },

  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  watch: {
    HasIP: function (newVal) {
      if (newVal) {
        if (this.intellectualProperty.length === 0) {
          this.add();
        }
      } else {
        this.intellectualProperty = [];
      }
    },
  },

  created() {
    this.getIP();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  },
};
</script>

<style lang="scss" scoped>
.field-title {
  .en-text {
    opacity: 0.6;
    font-size: 0.85em;
    margin-left: 5px;
  }
}

button {
  border: none;
  border-radius: 5px;
  padding: 5px 10px;
  font-size: 15px;
}

.del-btn {
  background: #ff3232;
  margin: 0px 10px 10px 0;
  color: #fff;
}
@media (max-width: 768px) {
  .del-btn {
    margin: 0;
  }
}

.edit-btn-wrap {
  margin-top: 20px;
  button {
    background: #18c58b;
    color: #fff;
  }
  .add-btn {
    background: #fff;
    color: #000;
    margin-right: 5px;
  }
}

/deep/ .el-input.is-disabled .el-input__inner {
  background-color: #fff;
  color: #5b5b5b;
  cursor: default;
}

/deep/ .el-textarea.is-disabled .el-textarea__inner {
  background-color: #fff;
  color: #5b5b5b;
  cursor: default;
}
</style>
